import { createSelector } from 'reselect';
import { recipientsSelector } from './recipients';

const threadsSelector = state => state.messaging.threads.messages;
const threadFilterSelector = state => state.messaging.threads.threadFilter;
const threadUnreadSelector = state => state.messaging.threads.filterUnread;
const threadStaredSelector = state => state.messaging.threads.filterStared;

export const getFilteredThreads = createSelector(
  threadsSelector,
  threadFilterSelector,
  threadUnreadSelector,
  threadStaredSelector,
  recipientsSelector,
  (threads, filter, filterUnread, filterStared, recipients) =>
    threads
      .map((message, user) => {
        return {
          recipient: recipients.get(user.toString()),
          message,
        };
      })
      .filter(m => !!m.recipient)
      .filter(m => isThreadVisible(m, filter))
      .filter(m => isThreadUnread(m, filterUnread))
      .filter(m => isThreadStared(m, filterStared))
      .sortBy(m => m.message.sent_at)
      .reverse()
      .toArray()
);

function isThreadVisible(thread, filter = '') {
  if (filter) {
    const { recipient } = thread;
    return (
      recipient.name &&
      recipient.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
    );
  }

  return true;
}

function isThreadUnread(thread, filterUnread) {
  const { message } = thread;
  return !filterUnread || message.index - message.lastReadIndex > 0;
}

function isThreadStared(thread, filterStared) {
  const { message } = thread;
  return !filterStared || message.isStared;
}



// WEBPACK FOOTER //
// ./src/modules/messaging/selectors/threads.js